export enum eOrdersQueryParams {
	ReferenceName = 'ReferenceName',
}
export enum eOrdersQueryBadge {
	ReferenceName = 'Ref',
}
